module.exports = __webpack_public_path__ + "img/401.1ef94d9c.png";